module.exports = __webpack_public_path__ + "static/img/anime-two.0a576e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/anime-two.png
// module id = B/tg
// module chunks = 0